import { useIsMobile } from "@/shared/adaptive/use-is-mobile";
import Popover from "@/shared/data-display/popover";
import Button from "@/shared/form/button";
import { FilterOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { useTranslations } from "use-intl";

export function FilterContainerWrapper({
  children,
  primary,
  search,
  showOnlyPrimary = false,
  showOnlyOther = false,
}: {
  children: ReactNode;
  primary?: ReactNode;
  search?: boolean;
  showOnlyPrimary?: boolean;
  showOnlyOther?: boolean;
}) {
  if (showOnlyPrimary) {
    return primary;
  }

  if (showOnlyOther) {
    return <FilterPopover>{children}</FilterPopover>;
  }

  return (
    <div className="w-full flex space-x-2">
      {primary && <div className="grow">{primary}</div>}
      {!search && <FilterPopover>{children}</FilterPopover>}
    </div>
  );
}

function FilterPopover({ children }: { children: ReactNode }) {
  const t = useTranslations("FilterContainer");
  const isMobile = useIsMobile();

  return (
    <div>
      <Popover
        trigger={["click"]}
        content={<div className="w-72 xl:w-96">{children}</div>}
        autoAdjustOverflow
      >
        <Button icon={<FilterOutlined />} type="primary">
          {!isMobile ? t("Filters") : undefined}
        </Button>
      </Popover>
    </div>
  );
}
